import Box from "./Box";
import CourierServiceFinder from "./CourierServiceFinder";
import Divider from "./Divider";
import FormCheckbox from "./FormCheckbox";
import FormError from "./FormError";
import FormFieldGroup from "./FormFieldGroup";
import FormInput from "./FormInput";
import Loading from "./Loading";
import LozengeButton from "./LozengeButton";
import NumberedItem from "./NumberedItem";
import PropTypes from "prop-types";
import React from "react";
import Stack from "./Stack";
import SelectRow from "./SelectRow";
import StoreFinder from "./StoreFinder";

function Form({ fields, handleChange, handleSubmit, error, submitting }) {
  return (
    <>
      <Stack
        divider={<Divider />}
        itemBoxProps={{ pt: [30, null, null, 50], pb: [30, null, null, 50] }}
      >
        {fields.map((field, index) => {
          let formItemComponent;
          if (field.type === "checkbox") {
            formItemComponent = (
              <FormCheckbox
                key={index}
                name={field.name}
                checked={field.value}
                error={field.error}
                label={field.label}
                handleChange={() => {
                  handleChange({
                    [field.name]: {
                      value: !field.value,
                      error: null,
                    },
                  });
                }}
              />
            );
          } else if (field.type === "courier_service_finder") {
            formItemComponent = (
              <CourierServiceFinder
                postcodeValue={field.postcodeValue}
                postcodeError={field.postcodeError}
                courierServiceValue={field.courierServiceValue}
                courierServiceError={field.courierServiceError}
                labelTypeValue={field.labelTypeValue}
                labelTypeError={field.labelTypeError}
                handleChange={(event) => {
                  handleChange({
                    [field.name]: {
                      value: event.target.value,
                      error: null,
                    },
                  });
                }}
              />
            );
          } else if (field.type === "form_field_group") {
            formItemComponent = (
              <FormFieldGroup
                fields={field.fields}
                handleChange={(value) => {
                  handleChange(value);
                }}
              />
            );
          } else if (field.type === "double_select") {
            formItemComponent = (
              <SelectRow
                fields={field.fields}
                explaination={field.explaination}
                handleChange={(value) => {
                  handleChange(value);
                }}
              />
            );
          } else if (
            field.type === "text" ||
            field.type === "email" ||
            field.type === "tel"
          ) {
            formItemComponent = (
              <FormInput
                key={index}
                name={field.name}
                value={field.value}
                error={field.error}
                placeholder={field.placeholder}
                handleChange={(event) => {
                  handleChange({
                    [field.name]: {
                      value: event.target.value,
                      error: null,
                    },
                  });
                }}
                type={field.type}
                label={field.label}
                autoComplete={field.autoComplete}
              />
            );
          } else if (field.type === "store_finder") {
            formItemComponent = (
              <StoreFinder
                key={index}
                name={field.name}
                value={field.value}
                error={field.error}
                placeholder={field.placeholder}
                handleChange={(value) => {
                  handleChange({
                    [field.name]: {
                      value: value,
                      error: null,
                    },
                  });
                }}
                type={field.type}
                label={field.label}
                autoComplete={field.autoComplete}
              />
            );
          }
          return (
            <NumberedItem
              key={index}
              number={index + 1}
              itemBoxProps={{ pt: [null, null, "5px", null] }}
            >
              {formItemComponent}
            </NumberedItem>
          );
        })}
      </Stack>
      <Box py={[50, null, 80, null]} position="relative">
        <LozengeButton
          onClick={() => {
            handleSubmit();
          }}
          height="62px"
          width="170px"
          disabled={submitting}
        >
          {submitting ? <Loading size={30} /> : "Submit"}
        </LozengeButton>
        {error && (
          <FormError
            name="takebackForm"
            positionProps={{ top: [130, null, 160, null] }}
          >
            {error}
          </FormError>
        )}
      </Box>
    </>
  );
}

Form.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      error: PropTypes.string,
      placeholder: PropTypes.string,
      type: PropTypes.string.isRequired,
      label: PropTypes.string,
      autoComplete: PropTypes.string,
    })
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
};

export default Form;
